// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Ere42","notes":"Notes_notes__cM924"};